import { render, staticRenderFns } from "./sign-up.vue?vue&type=template&id=16fba15e&scoped=true"
import script from "./sign-up.vue?vue&type=script&lang=js"
export * from "./sign-up.vue?vue&type=script&lang=js"
import style0 from "./sign-up.vue?vue&type=style&index=0&id=16fba15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fba15e",
  null
  
)

export default component.exports